import React from 'react'
import { Card, CardHeader, CardBody } from 'reactstrap'
import './customCard.css';

export const CustomCard = ({ classCard = '', withHeader, title = '', children }) => {
    return (
        <>
            <Card className={`${classCard}`}>

                {withHeader ?
                    <CardHeader>
                        {title}
                    </CardHeader>
                    : null
                }

                <CardBody>
                    {children}
                </CardBody>
            </Card>
        </>
    )
}
